import React, { FunctionComponent } from "react";
import HeaderDropdownMenu from "../dropdown-menu";
import "./index.scss";
import useHeaderMenuController from "./controller";
import { Pages } from "../../app/pages";
import { IMicroFrontendHeaderMenus } from "../../../data/microfrontend-types";

const HeaderMenus: FunctionComponent = () => {
  const controller = useHeaderMenuController();
  const showNonSandboxNav = !(
    controller.isApiUnificationToggleEnabled && controller.environmentConfig.isSandbox
  );

  function renderEventsMenu() {
    return (
      <HeaderDropdownMenu
        key="header-menu-events"
        dropdownItems={[]}
        label="Events"
        url="/events"
      />
    );
  }

  function renderMffMenus(menuGroupKey: string, menus: IMicroFrontendHeaderMenus | null) {
    return menus?.map((menu) => (
      <HeaderDropdownMenu
        key={`${menuGroupKey}-${menu.label}-${menu.url ?? ""}`}
        dropdownItems={menu.dropdownItems || []}
        label={menu.label}
        url={menu.url}
      />
    ),
    ) || null;
  }

  function renderCatalogueMenu() {
    return (
      <HeaderDropdownMenu
        key="header-menu-catalogue"
        dropdownItems={[]}
        label={Pages.CATALOGUE.title}
        url={Pages.CATALOGUE.path}
      />
    );
  }

  return (
    <div className="HeaderMenus">
      {showNonSandboxNav && renderCatalogueMenu()}
      {renderMffMenus("api-gw", controller.apiGwMenus)}
      {showNonSandboxNav && renderEventsMenu()}
      {renderMffMenus("data-catalogue", controller.dataCatalogueMenus)}
      {renderMffMenus("master-data", controller.masterDataMenus)}
      {controller.isTlmMicroFrontendToggleEnabled && renderMffMenus("tlm", controller.tlmMenus)}
      {controller.isAiMicroFrontendToggleEnabled && renderMffMenus("ai", controller.aiWorksMenus)}
      {controller.isAdrMicroFrontendToggleEnabled && renderMffMenus("adr", controller.adrMenus)}
    </div>
  );
};

export default HeaderMenus;
